// Helper de mesure GA4 pour Mitonner.
// IMPORTANT : aucune donnée personnelle (nom, prénom, e-mail, téléphone, adresse) n'est
// transmise à Google Analytics. On n'envoie que des identifiants techniques non nominatifs
// (reservation_id, clé de formule, nombre de personnes, montant, code secteur).
export const track = (event, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', event, params);
    }
  } catch (e) {
    // La mesure ne doit jamais casser l'application.
  }
};

// ==================== GOOGLE ADS (conversions publicitaires) ====================
// Le Conversion ID est déjà déclaré dans index.html (AW-18463999035), sur le même gtag.js
// que GA4 (aucun doublon GA4, aucun changement des événements Analytics existants).
// Le Conversion Label (spécifique à l'action de conversion "Achat" créée dans Google Ads)
// doit être renseigné ci-dessous. Tant qu'il est vide, AUCUNE conversion n'est envoyée.
export const GOOGLE_ADS_CONVERSION_ID = 'AW-18463999035';
export const GOOGLE_ADS_PURCHASE_CONVERSION_LABEL = ''; // <-- à renseigner (Conversion Label Google Ads)

// Déclenche la conversion d'achat Google Ads UNIQUEMENT pour une réservation réellement payée.
// value = montant réel payé (EUR), transaction_id = identifiant unique pour dédupliquer.
export const trackAdsPurchaseConversion = ({ value, transaction_id } = {}) => {
  try {
    if (!GOOGLE_ADS_PURCHASE_CONVERSION_LABEL) return; // pas de label => rien n'est envoyé
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', 'conversion', {
        send_to: `${GOOGLE_ADS_CONVERSION_ID}/${GOOGLE_ADS_PURCHASE_CONVERSION_LABEL}`,
        value: value || 0,
        currency: 'EUR',
        transaction_id: transaction_id || '',
      });
    }
  } catch (e) {
    // La mesure ne doit jamais casser l'application.
  }
};
